import { useT } from '@/i18n/runtime';
import type { TenantConfig } from '@/theme/tenant';
import { AppBar } from './components/AppBar';
import { Button } from './components/Button';
import { Icon } from './components/Icon';
import { NoticeBody } from './components/NoticeBody';
import { HelpStepMarker } from './help/HelpContext';

/**
 * The bystander-minimisation prompt before the first interior shot (FSD §14; SV-8-3). When the be issued the
 * pack's SV_BYSTANDER_MINIMISATION_PROMPT with the exchange, ITS text is shown (the ratifiable one); else the deck's.
 */
export function BystanderInterstitial({ tenant, onAck, body }: { tenant: TenantConfig; onAck: () => void; body?: string | null }): JSX.Element {
  const { t } = useT();
  return (
    <div className="app-view">
      <HelpStepMarker screen="other" tenantName={tenant.name} />
      <AppBar tenant={tenant} subtitle={t('sv.subtitle')} />
      <div className="app-view center" style={{ paddingTop: 24 }}>
        <div className="center-col" style={{ maxWidth: '34ch' }} data-testid="bystander-interstitial">
          <span className="perm-gate-badge"><Icon name="users" size={30} /></span>
          {body ? (
            <NoticeBody body={body} testId="bystander-notice-body" />
          ) : (
            <>
              <div className="h-title sm">{t('sv.capture.bystander.title')}</div>
              <p className="sub" style={{ marginTop: 8 }}>{t('sv.capture.bystander.body')}</p>
            </>
          )}
          <Button style={{ marginTop: 18 }} onClick={onAck}>{t('sv.capture.bystander.cta')}</Button>
        </div>
      </div>
    </div>
  );
}
